// import { faFlowerTulip } from "@jewlr/pro-light-svg-icons/faFlowerTulip"
// import { faGift } from "@jewlr/pro-light-svg-icons/faGift"
import { faTruckFast } from "@jewlr/sharp-light-svg-icons/faTruckFast"
// import { faBoxHeart } from "@jewlr/pro-regular-svg-icons/faBoxHeart"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Media from "components/ui/media"
import {
  IS_PORTAL,
  jewlr_t,
  IS_GE_CHECKOUT,
  IS_UK,
  IS_AU,
} from "helpers/application"
import { cn } from "styles/utils"

const ShipMethod = ({ className = "", pdpPricingHierarchyExp, ...props }) => (
  <p
    className={cn(
      "text-14 text-black",
      pdpPricingHierarchyExp === 1 ? "font-semibold" : "font-medium",
      className
    )}
    {...props}
  />
)

ShipMethod.propTypes = {
  className: PropTypes.string,
  pdpPricingHierarchyExp: PropTypes.number,
}

const LineItemShipping = ({ item }) => {
  // const forHer = item.product_gender === "female"
  const is_ge_checkout = IS_GE_CHECKOUT()
  const is_uk_or_au = IS_AU() || IS_UK()
  const pdpPricingHierarchyExp = useSelector(
    (state) => state.experiment.pdpPricingHierarchy.variant_id
  )

  return (
    <div className="text-14 leading-18 desktop:mt-24 my-16">
      {item.holiday_availability &&
        (pdpPricingHierarchyExp === 1 ? (
          <div className="tablet:flex text-sale-pink mb-8 hidden items-center">
            <FontAwesomeIcon className="mr-4" icon={faTruckFast} />
            <p className="text-16 font-semibold">
              Arrives Before{" "}
              {sl.config.guaranteed_holiday_alias ||
                sl.config.guaranteed_holiday}
            </p>
          </div>
        ) : (
          <Media className="mb-4" greaterThanOrEqual="tablet">
            <div className="text-ruby flex items-center">
              <FontAwesomeIcon className="mr-4" icon={faTruckFast} />
              <p className="text-16 font-semibold">
                Arrives Before{" "}
                {sl.config.guaranteed_holiday_alias ||
                  sl.config.guaranteed_holiday}
              </p>
            </div>
          </Media>
        ))}
      {(!is_ge_checkout || is_uk_or_au) &&
      item.delivery_dates &&
      item.delivery_dates.length > 0 ? (
        item.delivery_dates.map((d) => (
          <ShipMethod
            className={cn(
              pdpPricingHierarchyExp === 0 &&
                (d.type.includes(IS_PORTAL() ? "Standard" : "FREE")
                  ? "text-black"
                  : "text-emerald")
            )}
            data-cy={`itemShipping-${d.type}`}
            key={`itemShipping-${d.type}`}
            pdpPricingHierarchyExp={pdpPricingHierarchyExp}
          >
            {pdpPricingHierarchyExp === 1 ? (
              <>
                <span>{d.type}</span>{" "}
                {!d.date_range?.length > 0 && (
                  <span className="text-sale-pink">{d.date}</span>
                )}
                {d.date_range?.length > 0 && (
                  <>
                    <span className="text-sale-pink">{d.date_range[0]}</span> to{" "}
                    <span className="text-sale-pink">{d.date_range[1]}</span>
                  </>
                )}
              </>
            ) : (
              <>
                <span className="font-semibold">{d.type}</span>{" "}
                {!d.date_range?.length > 0 && (
                  <span className="italic">{d.date}</span>
                )}
                {d.date_range?.length > 0 && (
                  <>
                    <span className="italic">{d.date_range[0]}</span> to{" "}
                    <span className="italic">{d.date_range[1]}</span>
                  </>
                )}
              </>
            )}
          </ShipMethod>
        ))
      ) : item.delivery_date_range ? (
        <ShipMethod pdpPricingHierarchyExp={pdpPricingHierarchyExp}>
          {IS_PORTAL() ? "Standard" : "Free"} {jewlr_t("terms.Shipping")}{" "}
          <span
            className={cn(
              pdpPricingHierarchyExp === 1 ? "text-sale-pink" : "italic"
            )}
          >
            {item.delivery_date_range[0]}-{item.delivery_date_range[1]}
          </span>
        </ShipMethod>
      ) : (
        <ShipMethod pdpPricingHierarchyExp={pdpPricingHierarchyExp}>
          Ships by{" "}
          <span
            className={cn(
              pdpPricingHierarchyExp === 1 ? "text-sale-pink" : "italic"
            )}
          >
            {item.est_ship_date}
          </span>
        </ShipMethod>
      )}
    </div>
  )
}

LineItemShipping.propTypes = {
  item: PropTypes.object,
}

export default LineItemShipping
